import { Fundraiser, FundraiserListItem } from '~/types/campaign';
import { apiUrl, authHeaders } from './auth';
import queryString from 'query-string';

export const fetchFundraisers = async (
  page = 1,
  pageSize = 20,
  status: string | null,
  campaign_id?: string
): Promise<FundraiserListItem[]> => {
  const headers = authHeaders();
  const params = queryString.stringify(
    { page, pageSize, campaign_id, status },
    {
      skipNull: true,
      skipEmptyString: true,
    }
  );
  const url = apiUrl + `/v2/campaignFundraisers?${params}`;
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchFundraiser = async (
  fundraiser_id: string,
  campaign_id?: string
): Promise<Fundraiser> => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaignFundraisers/' + fundraiser_id;
  const url = campaign_id ? baseUrl + '?campaign_id=' + campaign_id : baseUrl;
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchRegistrations = async (
  fundraiser_id: string,
  campaign_id?: string
) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/fundraiserRegistrations/' + fundraiser_id;
  const url = campaign_id ? baseUrl + '?campaign_id=' + campaign_id : baseUrl;
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchRegistrationDetails = async (
  fundraiser_id: string,
  campaign_id?: string
) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + `/v2/registrationDetails/${fundraiser_id}`;
  const url = campaign_id ? baseUrl + '?campaign_id=' + campaign_id : baseUrl;
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

